"use client"

import Image from "next/legacy/image"
import { useEffect, useState } from 'react'
import MessageHelper from '@utils/messageHelper'
import Icon from '@components/shared/Icon'
import copyTextToClipboard from '@utils/clipboard/copyToClipboard'
import useT from '@hooks/useTranslation'

const facebookShareLink = (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
const twitterShareLink = (url) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(url)}`

const linkProps = {
    rel: 'noreferrer',
    target: '_blank',
    style: {
        alignItems: 'center',
        background: 'var(--dark-blue)',
        borderRadius: '50%',
        display: 'flex',
        height: 42,
        justifyContent: 'center',
        padding: '6px',
        width: 42,
    },
}

const innerIconStyle = {
    color: '#fff',
    fontSize: 23,
}

const dropdownIconStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 216,
    position:'absolute',
}

function Share ({ iconStyle, mobile }) {
    const [url, setUrl] = useState('')

    useEffect(() => {
        if (!url) setUrl(window.location.href)
    }, [url])

    const t = {
        blad: useT('Nieudane kopiowanie do schowka'),
        facebook: useT('Udostępnij na Facebooku'),
        skopiowano: useT('Skopiowano link do schowka'),
        skopiuj: useT('Skopiuj do schowka'),
        twitter: useT('Udostępnij na X (Twitterze)'),
        udostepnij: useT('Udostępnij'),
    }

    const copy = () => copyTextToClipboard(url,MessageHelper,t.skopiowano,t.blad)

    const clipboard = mobile && <span href="#" role="button" onClick={copy} title={t.skopiuj} {...linkProps}>
        <Icon style={innerIconStyle}>content_copy</Icon>
    </span>

    const facebook = <a href={facebookShareLink(url)} {...linkProps} title={t.facebook}>
        <Image src="/svg/facebook.svg" alt="facebook" width="28" height="28" />
    </a>

    const twitter = <a href={twitterShareLink(url)} {...linkProps} title={t.twitter}>
        <Image src="/svg/twitter.svg" alt="twitter" width="28" height="28" />
    </a>

    if (!url) return null
    return mobile
        ? <DropDown icon="share" iconStyle={iconStyle}>
            {clipboard}
            {facebook}
            {twitter}
          </DropDown>

        : <>
            {facebook}
            {twitter}
          </>
}

function DropDown ({ children, icon, iconStyle, text }) {
    const [show,setShow] = useState(false)
    const toggle = () => setShow(!show)
    return <div style={{alignItems:'center',display:'flex',zIndex:5}} onClick={toggle} role="button">
        <Icon style={iconStyle}>{icon}</Icon> {text}
        { show && <span style={dropdownIconStyle}>{children}</span> }
    </div>
}

export default Share